import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
    selector: 'shared-logout',
    templateUrl: './shared-logout.component.html',
    styleUrls: ['./shared-logout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      CommonModule,
      MatDialogModule
    ]
})
export class SharedLogoutComponent implements OnInit {
  public data = inject<{ counter: number }>(MAT_DIALOG_DATA);
  private _dialogRef = inject(MatDialogRef<SharedLogoutComponent>);
  private cd = inject(ChangeDetectorRef);

  counter: number;

  ngOnInit() {
    this.counter = this.data.counter;
  }

  confirmDialog() {
    this._dialogRef.close(false);
    this.cd.detectChanges();
  }

  updateCounter(newCounter: number): void {
    this.counter = newCounter;
    this.cd.detectChanges();
  }

  closeDialog() {
    this._dialogRef.close(true);
    this.cd.detectChanges();
  }
}
